import { useCallback } from 'react'

import { type UseClickActionArgs } from '@src/hooks/useClickAction/useClickActionArgs'
import {
  useTrackSelectCta,
  useTrackSelectNavCta,
  useTrackSelectPencilBannerCta,
  useTrackSelectRailCta,
  useTrackSelectStickyFooterCta,
} from '@src/utils/analytics.util'

const DEFAULT_ANALYTICS_MODULE = 'unknown'

export const useTrackNavigate = ({
  navigate,
  analyticsModule,
}: {
  navigate?: UseClickActionArgs['navigate']
  analyticsModule?: string
}) => {
  const trackSelectCta = useTrackSelectCta()
  const trackSelectNavCta = useTrackSelectNavCta()
  const trackSelectStickyFooterCta = useTrackSelectStickyFooterCta()
  const trackSelectPencilBannerCta = useTrackSelectPencilBannerCta()
  const trackSelectRailCta = useTrackSelectRailCta()

  const trackNavigate = useCallback(() => {
    if (navigate?.href) {
      const params = {
        'cta url': navigate.href,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        module: analyticsModule || DEFAULT_ANALYTICS_MODULE,
      }
      switch (navigate.analyticsEvent) {
        case 'select cta':
          trackSelectCta(params)
          break
        case 'select nav cta': {
          trackSelectNavCta(params)
          break
        }
        case 'select sticky footer cta': {
          trackSelectStickyFooterCta(params)
          break
        }
        case 'select pencil banner cta': {
          trackSelectPencilBannerCta(params)
          break
        }
        case 'select rail cta': {
          trackSelectRailCta(params)
          break
        }
      }
    }
  }, [
    analyticsModule,
    navigate?.analyticsEvent,
    navigate?.href,
    trackSelectCta,
    trackSelectNavCta,
    trackSelectPencilBannerCta,
    trackSelectRailCta,
    trackSelectStickyFooterCta,
  ])

  return { trackNavigate }
}
